import Quill from "quill"

import "./quill_extensions/blob_image"
import "./quill_extensions/signature_image"
import "./quill_extensions/html_block"
import "./quill_extensions/image_drop_and_paste"
import "./quill_extensions/link-converter"
import "./quill_extensions/chars-counter"
import "./quill_extensions/inline_styles"
import "./quill_extensions/uploader"

import "quill-mention/autoregister"
import "quill-paste-smart"

import BlotFormatter2 from "./quill_extensions/quill-blot-formatter2/src"
Quill.register("modules/blotFormatter2", BlotFormatter2)
